import { Alert, Toaster } from "@amzn/meridian";
import React, { useState } from "react";
import { Toast } from "src/data/types";
import { deleteToast } from "src/store/layoutSlice";
import { useAppDispatch, useAppSelector } from "src/store/store";

const AppToaster = () => {
  const { appToasts } = useAppSelector((state) => state.layout);
  const dispatch = useAppDispatch();

  return (
    <div>
      <Toaster
        toasts={appToasts}
        onCloseToast={(id) => dispatch(deleteToast(id))}
      >
        {(toast) => (
          <Alert toast={true} onClose={toast.onClose} type={toast.type}>
            {toast.message}
          </Alert>
        )}
      </Toaster>
    </div>
  );
};

export default AppToaster;
